import React from 'react';
import { Table as AntTable, Empty } from 'antd';
import { useTranslation } from 'react-i18next';

import { languages } from '../../../constants';

import style from './ExtendableTable.module.scss';

// eslint-disable-next-line max-len
export const ExtendableTable = ({ id, additionalStyle, additionalSubStyle, columns, subColumns, thirdColumns, data, emptyDataMessage, loading = false, ...props }) => {

  const expandedRowRender = item => (

    <>
      <AntTable
        className={ `${style.subTable} ${style[additionalSubStyle]}` }
        columns={ subColumns }
        dataSource={ [ item ] }
        pagination={ false }
        size="small"
        bordered={ false }
      />
      {thirdColumns && (
        <>
          <br />
          <AntTable
            className={ style.subTable }
            columns={ thirdColumns }
            dataSource={ [ item ] }
            pagination={ false }
            size="small"
            bordered={ false }
          />
        </>
      )}

    </>
  );
  const i18n = useTranslation();
  const align = i18n[1].language === languages.EN ? 'left' : 'right';

  columns.map(e => {
    e.align = align;

    return e;
  });
  subColumns && subColumns.map(e => {
    e.align = align;

    return e;
  });

  return (
    <div
      data-testid={ id }
      style={{
      overflowX: 'scroll'
      }}
    >

      <AntTable
        className={ `${style.table} ${style[additionalStyle]}` }
        columns={ columns }
        dataSource={ data }
        size="middle"
        loading={ loading }
        pagination={ false }
        align={ align }
        scrollToFirstRowOnChange={ true }
        expandedRowRender={ subColumns ? expandedRowRender : false }
        expandIcon={ subColumns
          ? a => (
            <div
              data-testid={ `${id}-expand` }
              className={ a.expanded ? style.shrink : style.expand }
            >
              <p>{a.expanded ? '-' : '+'}</p>
            </div>
)
        : false }
        expandRowByClick={ true }
        rowClassName={ record =>
          (record?.escalated ? style.escalationRow : '')
        }
        locale={{ emptyText: <Empty description={ emptyDataMessage } image={ Empty.PRESENTED_IMAGE_SIMPLE } /> }}
        { ...props }
      />


    </div>
  );
};
